import { IAdditionalSettingsItem } from '@game-studio/arcade-base';

export function getAdditionalSettings(): IAdditionalSettingsItem[] {
    const additionalSettings: IAdditionalSettingsItem[] = [];
    return additionalSettings;
}
